export enum DepositInvoiceAmountType {
  Fixed = 'fixed',
  Percentage = 'percentage',
}
